import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { RolesComponent } from './roles.component'
import { CreateRoleComponent } from './create-role/create-role.component'
import { UpdateRoleComponent } from './update-role/update-role.component'
import { RolesRoutes } from './roles.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [RolesComponent, CreateRoleComponent, UpdateRoleComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(RolesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [RolesComponent, CreateRoleComponent, UpdateRoleComponent],
})
export class RolesModule {}
